module.exports = __webpack_public_path__ + "img/close-blue.bd5a7546.svg";